import styled from 'styled-components'

export const ResourceRowContainer = styled.div`
  padding: 64px 0 0 0;
  background: ${p => p.theme.webMktPalette.background.gray};

  .ResourseRow_Intro {
    text-align: center;
  }

  .ResourseRow_Intro + div {
    padding-top: 64px;
  }
`
